<!--
 * @Description:
 * @Author: 王佳兴
 * @Github:
 * @Date: 2019-01-15 17:21:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-26 14:38:51
 -->
<template>
  <div class="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="200px"
      class="ruleForm"
    >
      <el-form-item label="项目：" prop="projectName">
        <el-tooltip
          effect="dark"
          :content="ruleForm.projectName"
          placement="top"
        >
          <el-input v-model="ruleForm.projectName" disabled />
        </el-tooltip>
      </el-form-item>
      <el-form-item label="接单企业：" prop="enterpriseName">
        <el-input v-model="ruleForm.enterpriseName" disabled />
      </el-form-item>
      <el-form-item label="病例照片描述：" prop="imgList">
        <ul class="pic-wrap">
          <li
            v-for="(item, index) in ruleForm.imgList"
            :key="index"
            class="sampleBox"
          >
            <el-input
              :disabled="ifDisable"
              v-model="item.imgDescribe"
              maxlength="100"
              show-word-limit
            ></el-input>
            <el-button
              class="pic-button"
              @click="delImgList(index)"
              v-show="index > 0"
              :disabled="ifDisable"
            >
              删除
            </el-button>
          </li>
          <div style="min-height: 30px">
            <!--新增按钮隐藏后支撑高度-->
            <el-button
              class="pic-button add-button"
              @click="pushImgList"
              v-show="ruleForm.imgList.length < 10"
              :disabled="ifDisable"
            >
              新增
            </el-button>
          </div>
        </ul>
      </el-form-item>
      <el-form-item label="项目结算单价（税前）：" prop="yuanPrice">
        <div style="display:flex;">
          <el-input v-model="yuanPrice" :disabled="ifDisable"></el-input>
          元
        </div>
      </el-form-item>
      <!--      todo 添加税率字段,匹配对应的验证器 -->
      <el-form-item class="input-width" label="税率：" prop="contractScale">
        <el-input
          class="percentage"
          v-model="ruleForm.contractScale"
          :disabled="ifDisable"
        ></el-input>
      </el-form-item>
      <el-form-item label="总任务量：" prop="taskSum">
        <el-input
          v-model="ruleForm.taskSum"
          maxlength="10"
          :disabled="ifDisable"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm', 2)"
          :loading="btLoading"
          :disabled="ifDisable"
        >
          保 存
        </el-button>
        <el-button
          type="primary"
          @click="db"
          :loading="btLoading"
          :disabled="ifDisable"
        >
          {{ isConfirm ? '已确认' : '确认' }}
        </el-button>
        <next-project-btn :info="ruleForm" :submitFn="db"></next-project-btn>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { btLoading } from '@/Mixin/btLoading';
/**
 * dbCon
 * setLocalProjectStatus db (methods)
 * isConfirm ifDisable (computed)
 *  */
import { dbCon } from '@/Mixin/doubleConfirm';
import { channel, bingli } from '@/api/ajax';
import { courseType, whetherOrNot } from '@/assets/staticData';
import dicSelect from '@/components/Common/dicSelect.vue';
import UploadImgOne from '@/components/Common/UploadImgOne.vue';
import { priceFilter, isInteger, checkTax } from '@/tools/formCheck';
import { moneyComplete, moneyInt } from '@/tools/money';
import nextProjectBtn from '@/components/Judge/NextProjectBtn.vue';
export default {
  mixins: [btLoading, dbCon],
  data() {
    const checkImg = (rule, value, callback) => {
      if (
        this.ruleForm.imgList.length == 0 ||
        this.ruleForm.imgList[0].imgDescribe == ''
      ) {
        callback(new Error('病例照片描述不能为空'));
      } else {
        callback();
      }
    };
    const checkYuan = (rule, value, callback) => {
      if (!this.yuanPrice) {
        callback(new Error('任务单价不能为空'));
      } else if (isNaN(this.yuanPrice)) {
        callback(new Error('请填写数字'));
      } else if (this.yuanPrice <= 0) {
        callback(new Error('不能小于0'));
      } else {
        callback();
      }
    };
    return {
      ifDisable: false,
      whetherOrNot,
      courseType,
      searchAjax: null,
      prop: {
        label: 'enterpriseName',
        code: 'id'
      },
      initSummary: '',
      initRoleImg: '',
      initProgram: '',
      fuckShow: [
        {
          label: '是',
          value: 1
        },
        {
          label: '否',
          value: 2
        }
      ],
      ruleForm: {
        id: this.$route.query.id,
        bingliCount: 2,
        enterpriseId: '',
        imgList: [{}],
        projectName: '',
        contractScale: null
      },
      yuanPrice: '',
      // 校验
      rules: {
        projectName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        enterpriseName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        picUrl: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        yuanPrice: [
          {
            validator: checkYuan,
            required: true,
            trigger: 'blur'
          }
        ],
        taskSum: [
          {
            required: true,
            validator: isInteger,
            trigger: 'blur'
          }
        ],
        imgList: [
          {
            validator: checkImg,
            trigger: 'blur',
            required: true
          }
        ],
        contractScale: [
          {
            required: true,
            validator: checkTax,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  components: {
    nextProjectBtn,
    dicSelect,
    UploadImgOne
  },
  computed: {},
  methods: {
    pushImgList() {
      this.ruleForm.imgList.push({
        createDt: '',
        id: '',
        imgDescribe: '',
        projectId: '',
        weight: ''
      });
    },
    delImgList(index) {
      this.ruleForm.imgList.splice(index, 1);
    },
    resetForm(formName) {
      this.ruleForm.projectStatus = !(type === 0);
    },
    coverPicDone(v) {
      this.ruleForm.picUrl = v;
    },
    submitForm(formName, type) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            // 改变按钮状态
            this.SET_BTLOADING(true);
            // 混合对象 格式化数据
            let describeList = [];
            for (var item of this.ruleForm.imgList) {
              describeList.push(item.imgDescribe);
            }
            this.ruleForm.imgDescribe = describeList;
            this.ruleForm.projectPrefix = 'sass';
            this.ruleForm.type = type;
            this.ruleForm.price = moneyComplete(this.yuanPrice);
            bingli
              .addUpdateBingliProject(this.ruleForm)
              .then(res => {
                resolve('submit_success');
                this.$notify({
                  title: '成功',
                  message: '操作成功',
                  type: 'success'
                });
                // this.resetForm();
                this.setLocalProjectStatus(type == 2 ? 0 : type);
              })
              .catch(() => {
                reject('submit_error');
              });
          } else {
            reject('submit_error');
            return false;
          }
        });
      });
    }
  },
  watch: {
    'ruleForm.contractScale'(value) {
      if (/\d+\.\d{3,}$/g.test('' + value)) {
        this.ruleForm.contractScale = Number(value).toFixed(2);
      }
      if (/\s/g.test(`${value}`)) {
        this.ruleForm.contractScale = `${value}`.replace(/\s/g, '');
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      bingli
        .loadProject({
          id: this.$route.query.id
        })
        .then(res => {
          let resp = res.data.data;
          this.ruleForm = resp;
          this.ruleForm.taskSum ? '' : (this.ruleForm.taskSum = 0);
          if (this.ruleForm.imgList.length == 0) {
            this.pushImgList();
          }
          this.yuanPrice = moneyInt(this.ruleForm.price);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.pic-wrap {
  margin-bottom: -20px;

  li {
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .pic-button {
    border: none;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #5a9cf8;
    line-height: 14px;

    &:hover {
      background-color: transparent;
    }

    &.add-button {
      background-color: transparent;
      padding: 0;
      margin-top: -9px;
    }
  }
}

.sampleBox {
  display: flex;
  align-items: center;

  img {
    width: 200px;
    height: 200px;
  }
}
</style>
